import React, { Fragment } from "react";
import Label from "./Label";

const RadioButton = passedProps => {
  const { name, required, label, options, value, ...props } = passedProps;
  return (
    <Fragment>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <div className="radiobutton">
        {options.map((option, i) => {
          const inputId = `${name}-${i}`;

          let id, description;
          if (typeof option === "string") {
            [id, description] = [option, option];
          } else {
            // assume it's an object of shape { id: 1, description: 'something' }
            ({ id, description } = option);
            id = String(id);
          }

          return (
            <div key={inputId} className="form-check">
              <input
                className="form-check-input"
                id={inputId}
                name={name}
                value={id}
                checked={value === id}
                type="radio"
                {...props}
              />
              <label className="form-check-label" htmlFor={inputId}>
                {description}
              </label>
            </div>
          );
        })}
      </div>
    </Fragment>
  );
};

export default RadioButton;
